import * as React from 'react'
import { SVGProps } from 'react'

const SvgChainLinkIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M0 0h24v24H0z' />
    <circle cx={12} cy={12} r={12} fill='#2A5ADA' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.468 4.844 11.936 4l1.468.844 4 2.312L18.872 8v8l-1.468.844-3.964 2.312-1.467.844-1.468-.844-4.037-2.312L5 16V8l1.468-.844 4-2.312ZM7.936 9.688v4.624l4 2.312 4-2.312V9.688l-4-2.312-4 2.312Z'
      fill='#fff'
    />
  </svg>
)

export default SvgChainLinkIcon
